import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactNode } from 'react';
import { ColorType } from '../../assets/colors/colors.g';

// Styles for the header component
const useStyles = makeStyles(() => ({
  header: {
    boxShadow: ` inset 0px -1px 0px ${ColorType.GREY2}`,
    backgroundColor: '#fff',
    position: 'sticky', // Sticks to top when scrolling
    top: '0px',
    maxWidth: '425px', // Mobile-first max width constraint
    zIndex: 1,
  },
  leftContent: {
    display: 'flex',
    alignItems: 'center',
  },
  rightContent: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto', // Pushes content to the right
  },
}));

interface SimpleHeaderProps {
  left?: ReactNode; // Content to display on the left side
  right?: ReactNode; // Content to display on the right side
  height?: number; // Header height in pixels (default: 60)
}

/**
 * A simple, sticky header component with left and right content areas.
 * Designed for mobile-first layouts with a max width constraint.
 */
export const SimpleHeader = ({ left, right, height = 60 }: SimpleHeaderProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      className={classes.header}
      style={{
        height: height,
        backgroundColor: '#fff',
        paddingLeft: '24px',
        paddingRight: '24px',
      }}
    >
      {left && (
        <Grid item className={classes.leftContent}>
          {left}
        </Grid>
      )}
      {right && (
        <Grid item className={classes.rightContent}>
          {right}
        </Grid>
      )}
    </Grid>
  );
};
